import { EVENT_NAME } from './constants';
const LEVEL_STYLES = {
    error: 'color:#ff4444;font-weight:bold',
    warn: 'color:#ffaa00;font-weight:bold',
    info: 'color:#44aaff;font-weight:bold',
    debug: 'color:#888;font-weight:bold',
};
const TIMESTAMP_STYLE = 'color:#888;font-variant-numeric:tabular-nums';
function formatTimestamp(ms) {
    return `${(ms / 1000).toFixed(3)}s`.padStart(10);
}
const CONSOLE_FN = {
    error: console.error,
    warn: console.warn,
    info: console.info,
    debug: console.log,
};
/**
 * Creates an event listener that renders InterlucentLogDetail events
 * to the browser console with %c styled colored output.
 *
 * Attach to the same EventTarget(s) the loggers dispatch on.
 */
export function createConsoleSink() {
    return (e) => {
        const detail = e.detail;
        const { level, source, module, message, format, data, timestamp } = detail;
        const fn = CONSOLE_FN[level] ?? console.log;
        const style = LEVEL_STYLES[level] ?? LEVEL_STYLES.debug;
        const ts = formatTimestamp(timestamp);
        const prefix = `[${source}:${module}]`;
        if (format === 'table' && data != null && typeof data === 'object') {
            fn(`%c${ts}%c %c${prefix}%c ${message}`, TIMESTAMP_STYLE, 'color:inherit', style, 'color:inherit');
            console.table(data);
        }
        else if (data !== undefined) {
            fn(`%c${ts}%c %c${prefix}%c ${message}`, TIMESTAMP_STYLE, 'color:inherit', style, 'color:inherit', data);
        }
        else {
            fn(`%c${ts}%c %c${prefix}%c ${message}`, TIMESTAMP_STYLE, 'color:inherit', style, 'color:inherit');
        }
    };
}
/**
 * Convenience: attach the console sink to a target.
 * Returns a cleanup function.
 */
export function attachConsoleSink(target) {
    const handler = createConsoleSink();
    target.addEventListener(EVENT_NAME, handler);
    return () => target.removeEventListener(EVENT_NAME, handler);
}
